import { jsx as u } from "react/jsx-runtime";
import { useRef as f } from "react";
import { useInView as d, motion as b } from "framer-motion";
import { cn as h } from "../../../lib/utils.js";
function w({ children: e, className: n, yOffset: r = 6, blur: t = "6px", duration: o = 0.4, delay: s = 0, inView: a = !1, inViewMargin: l = "-50px" }) {
  const i = f(null), m = d(i, {
    once: !0,
    margin: l
  }), c = a ? m : !0, p = {
    hidden: {
      opacity: 0,
      y: r,
      filter: `blur(${t})`
    },
    visible: {
      opacity: 1,
      y: 0,
      filter: "blur(0px)"
    }
  };
  return u(b.div, { ref: i, className: h(n), initial: "hidden", animate: c ? "visible" : "hidden", variants: p, transition: {
    delay: s,
    duration: o,
    type: "spring",
    bounce: 0
  }, children: e });
}
export {
  w as BlurFade
};
//# sourceMappingURL=BlurFade.js.map
